import { type QuestionType } from 'types/services/Family'
import { nutritionRules } from 'utils/definitionRecomedationRules/nutritionRules'
import handleFinalInfoCardAdjustments from 'utils/handleFinalInfoCardAdjustments'

/*
  🔵 Adiciona aos dados os atributos: isAlert, inconsistent. Onde os 
  alertas são calculados no front e as inconsistencias vem do back
*/

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function cardsInfosNutrition(family: any, inconsistencies: any) {
  const cardsInfos: QuestionType[] = Object.keys(family.nutritionInfo).map(
    (attribute: string) => {
      return {
        ...family.nutritionInfo[attribute],
        isAlert: nutritionRules(family, attribute),
        inconsistent: inconsistencies?.nutrition?.includes(attribute),
      }
    }
  )

  // função que confirma que um card não será alerta se for inconsistente e depois ordena os alertas para primeiro
  return handleFinalInfoCardAdjustments(cardsInfos)
}

export default cardsInfosNutrition
